<template>
  <div>
    <multiselect v-model="delegate" id="delegate" label="name" track-by="id" placeholder="Type to search" open-direction="bottom" :options="delegates" :multiple="false" :searchable="true" :internal-search="false" :clear-on-select="false" :close-on-select="true" :options-limit="300" :limit="1" :max-height="300" :show-no-results="false" :hide-selected="false" :show-labels="false" @search-change="search" @select="onSelected">
      <template slot="option" slot-scope="props">
        <div class="option__desc">
          <span class="option__title">{{ props.option.realPerson ? `${props.option.getName()} (${props.option.associationName})` : props.option.associationName }}</span>
        </div>
      </template>
      <template slot="noOptions">
        <span v-if="delegateType === 'association'">Start typing to see associations</span> <span v-else>Start typing to see delegates</span>
      </template>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import DelegateType from '../../enums/delegate-type'

export default {
  name: 'DelegateAutocomplete',
  components: {
    Multiselect
  },
  props: {
    delegateType: {
      type: String,
      default: DelegateType.BOTH
    }
  },
  data: function () {
    return {
      loading: false,
      delegate: null,
      delegates: []
    }
  },
  async created () {
    this.loading = true
    await this.$store.dispatch('delegates/load')
    this.delegates = this.delegateType === DelegateType.ASSOCIATION
      ? this.$store.getters['delegates/associations']
      : this.$store.getters['delegates/all']
    this.loading = false
  },
  methods: {
    search (query) {
      this.loading = true
      this.delegates = this.$store.getters['delegates/search'](query, this.delegateType)
      this.loading = false
    },
    onSelected (delegate) {
      this.$emit('selected', delegate)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/delegates/DelegateAutocomplete.vue